import script from "./manager.vue?vue&type=script&setup=true&lang=js"
export * from "./manager.vue?vue&type=script&setup=true&lang=js"

import "./manager.vue?vue&type=style&index=0&id=3d2af9f2&scoped=true&lang=css"

import exportComponent from "E:\\WebstormProjects\\sms-transfer-h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d2af9f2"]])

export default __exports__